import $ from "jquery";

const flexibleContentMenuItems = $(".flexible-content-menu-items"),
  flexibleContentMenuTitle = $(".flexible-content-menu .title"),
  flexibleContentSections = $(".flexible-content-blocks section");
let stickyHeaderHeight, resizeFlag;

function checkMobile() {
  if (flexibleContentMenuItems.length) {
    stickyHeaderHeight = $(".header-section--sticky").height() + 79;
    if ($(window).width() >= 992) {
      resizeFlag = false;
      flexibleContentMenuItems.slideDown();
    } else {
      resizeFlag = true;
      flexibleContentMenuTitle.removeClass("opened");
      flexibleContentMenuItems.slideUp();
    }
  }
}

function toggleMenuControl() {
  if (resizeFlag) {
    if (flexibleContentMenuItems.is(":visible")) {
      $(this).removeClass("opened");
      flexibleContentMenuItems.slideUp();
    } else {
      $(this).addClass("opened");
      flexibleContentMenuItems.slideDown();
    }
  } else {
    return false;
  }
}

function scrollTo(scrollTarget) {
  $("html, body").animate(
    {
      scrollTop:
        $('section[data-nav-title="' + scrollTarget + '"]').offset().top -
        stickyHeaderHeight,
    },
    500
  );
}

if ($(".flexible-content-blocks section[data-nav-title]").length) {
  flexibleContentMenuTitle.on("click", toggleMenuControl);

  $(window).on("resize", function () {
    checkMobile();
  });

  if (flexibleContentSections.length >= 8) {
    flexibleContentMenuItems.addClass("small-paddings");
  }

  $("body").addClass("has-nav");

  $.each(flexibleContentSections, function () {
    let menuItemTitle = $(this).attr("data-nav-title");
    if (typeof menuItemTitle !== "undefined") {
      let menuItem =
        '<span class="flexible-content-menu-item" tabindex="0" data-nav-title="' +
        menuItemTitle +
        '"><span class="border"></span>' +
        menuItemTitle +
        "</span>";
      flexibleContentMenuItems.append(menuItem);
    }
    checkMobile();
  });

  $(".flexible-content-menu-item").on("click", function (e) {
    e.preventDefault();
    let scrollTarget = $(this).attr("data-nav-title");
    $(".flexible-content-menu-item").removeClass("opened");
    $(this).addClass("opened");
    if (resizeFlag) {
      flexibleContentMenuItems.slideUp(100, function () {
        flexibleContentMenuTitle.removeClass("opened");
        scrollTo(scrollTarget);
      });
    } else {
      scrollTo(scrollTarget);
    }
  });

  $(".flexible-content-menu-item").on("keydown", function (e) {
    if (e.key == "Enter") {
      let scrollTarget = $(this).attr("data-nav-title");
      $(".flexible-content-menu-item").removeClass("opened");
      $(this).addClass("opened");
      if (resizeFlag) {
        flexibleContentMenuItems.slideUp(100, function () {
          flexibleContentMenuTitle.removeClass("opened");
          scrollTo(scrollTarget);
        });
      } else {
        scrollTo(scrollTarget);
      }
    }
  });
} else {
  $(".flexible-content-menu").hide();
  $("body").removeClass("has-nav");
}
